import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JwtService } from 'src/app/jwt.service';
import { BannerService } from 'src/app/services/banner.service';
import { ConfigService } from 'src/app/services/config.service';
import { ConfigAux } from 'src/app/services/configAux';
import { Banner } from 'src/app/persistences/banner';

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  bannersLogin: Banner[] = [];
  tempoSlideBanners: number = 5000;

  constructor(
    private router: Router,
    private bannerService: BannerService,
    private configService: ConfigService,
    private configAux: ConfigAux,
  ) {}

  ngOnInit(): void {
    if (JwtService.loggedIn()) {
      this.router.navigate(['/home']);
      return;
    }
    const config = this.configService.getConfig();
    if (config?.getIp) {
      this.inicializarConfigEBanners();
    } else {
      this.configAux.loadAppConfig()
        .then(() => this.inicializarConfigEBanners())
        .catch(() => {});
    }
  }
  
  private inicializarConfigEBanners(): void {
    this.configService.loadFullConfig()
      .catch(() => {})
      .finally(() => this.carregarBannersLogin());
  }

  private carregarBannersLogin(): void {
    this.tempoSlideBanners = this.configService.getConfig().getTempoSlideBanner;
    this.bannerService.getBannersTelaLogin().subscribe({
      next: (banners) => {
        this.bannersLogin = banners ?? [];
      },
      error: () => {
        this.bannersLogin = [];
      }
    });
  }
}
